import React from "react";
import PropTypes from "prop-types";
import { List, ListItem, ListItemText, Typography } from "@material-ui/core";

/**
 * La lista de una pestaña de detalle, con cuantos hay. Quien la usa traduce
 * sus datos a { principal, secundario, retirado? } (ver itemsDeDetalle), asi
 * que este componente no sabe de estudiantes ni de libros. Los `retirado` se
 * ven atenuados y no cuentan en el total.
 */
const ListaDetalle = ({ items, vacio }) => {
  if (items.length === 0) {
    return (
      <Typography variant="body2" color="textSecondary">
        {vacio}
      </Typography>
    );
  }
  const retirados = items.filter(({ retirado }) => retirado).length;
  return (
    <>
      <Typography variant="body2" color="textSecondary" style={{ marginBottom: 8 }}>
        {`${items.length - retirados} en total`}
        {retirados > 0 && ` · ${retirados} ${retirados === 1 ? "retirado" : "retirados"}`}
      </Typography>
      <List dense disablePadding>
        {items.map(({ principal, secundario, retirado }, indice) => (
          <ListItem key={`${principal}-${indice}`} disableGutters style={retirado ? { opacity: 0.6 } : undefined}>
            <ListItemText primary={principal} secondary={secundario} />
          </ListItem>
        ))}
      </List>
    </>
  );
};

ListaDetalle.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      principal: PropTypes.string,
      secundario: PropTypes.string,
      retirado: PropTypes.bool,
    }),
  ).isRequired,
  vacio: PropTypes.string.isRequired,
};

export default ListaDetalle;
